// import style from './index.css'
//
// const div = document.createElement('div')
// div.innerHTML = '<h1>Hello World</h1>'
// div.className = style.component
import React from 'react'
import {render} from 'react-dom'
import App from 'app'

render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./index.js